import { GET_ALL_DIVISIONS, GET_DIVISION, RESET_DIVISION, GET_DIVISIONS_FOR_SELECT } from './types'

const initialState = {
  divisions: [],
  division: {},
  loading: false,
  divisionForSelect: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DIVISION:
      return {
        ...state,
        division: action.payload,
      }
    case GET_ALL_DIVISIONS:
      return {
        ...state,
        divisions: action.payload,
      }
    case RESET_DIVISION:
      return {
        ...state,
        division: action.payload,
      }
    case GET_DIVISIONS_FOR_SELECT:
      return {
        ...state,
        divisionForSelect: action.payload,
      }
    default:
      return state
  }
}
